// extracted by mini-css-extract-plugin
export var cell = "_5d-4";
export var headerCell = "_5d-2";
export var rowHeader = "_5d-3";
export var table = "_5d-1";
export var tableContainer = "_5d-0";